import React from 'react';

import { Actions, Action, EditIcon, DeleteIcon } from '@gogame/components';

export default ({ onDelete, onEdit }) => (
  <Actions>
    <Action label={'Edit'} icon={<EditIcon />} onClick={onEdit} />
    <Action label={'Delete'} icon={<DeleteIcon />} onClick={onDelete} />
  </Actions>
);
